export const partnerEn = {
  partnerPage: 'Partnership',
  refLinkCopied: 'Referral link copied to clipboard'
}

export const partnerRu: typeof partnerEn = {
  partnerPage: 'Партнёрам',
  refLinkCopied: 'Реферальная ссылка скопирована'
}
